import { render, staticRenderFns } from "./ErrorInfoDialog.vue?vue&type=template&id=2f95ad28&scoped=true"
import script from "./ErrorInfoDialog.vue?vue&type=script&lang=js"
export * from "./ErrorInfoDialog.vue?vue&type=script&lang=js"
import style0 from "./ErrorInfoDialog.vue?vue&type=style&index=0&id=2f95ad28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f95ad28",
  null
  
)

export default component.exports